module.exports = __webpack_public_path__ + "img/5.5f3f14d.png";